module.exports = __webpack_public_path__ + "assets/img/18_922.46e830ab.jpg";